:host {
  --error-text: var(--red-layout-300-primary);
}

gz-dropdown-menu {
  width: 78px;

  &::part(main-label) {
    position: absolute;
    transform: translateY(-60%);
    top: 0px;
    margin-left: -6px;
    padding: 0 calc(var(--spacer) / 2);
    max-width: 90%;
    font-size: var(--body-size-xsmall);
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    &:before {
      content: '';
      position: absolute;
      background: var(--white-layout-301-level-0-elevation);
      top: auto;
      bottom: 0;
      z-index: -1;
      left: 0;
      width: 100%;
      height: 50%;
      pointer-events: none;
    }
  }

  &::part(dropdown-label) {
    border: none;
    height: 30px;
  }
}

gz-dropdown-menu::part(dropdown-button) {
  &:hover {
    background-color: unset;
  }
}

:host([error]) {
  gz-dropdown-menu {
    &::part(main-label) {
      color: var(--error-text);
    }
  }
}

:host([readonly]) {
  gz-dropdown-menu::part(main-label) {
    background: transparent !important;
  }

  gz-dropdown-menu::part(dropdown-label) {
    background-color: transparent;
  }

  gz-dropdown-menu::part(main-label) {
    &:before {
      background: transparent;
    }
  }
}
